import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function EyeOffIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M3 3l18 18" />
      <Path d="M10.6 5.6A10.4 10.4 0 0 1 12 5.5c6.5 0 10 6.5 10 6.5a17.6 17.6 0 0 1-3.2 4" />
      <Path d="M6.6 6.6C3.7 8.4 2 12 2 12s3.5 6.5 10 6.5c1.6 0 3-.4 4.3-1" />
      <Path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </LineIcon>
  );
}
